import c from "../../../utils/constants";

class SurveyFilterController {
  constructor($scope, FilterService) {
    "ngInject"

    this.filterService = FilterService;
    
    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true)
  }
  
  $onInit() {
    this.setFilterOptions();
  }

  setFilterOptions() {
    this.filterOptions = this.filterService.getSurveyFilterOptions();
  }

  onFilterChagne(newval, oldval) {
    this.filterService.generateFilterExpression(this.filterOptions);
    this.applyFilters();
  }
  
}

export default SurveyFilterController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/survey-filter/survey-filter.controller.js
 **/